module.exports = __webpack_public_path__ + "img/logo.d180963f.png";